/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundFaxUrlResponseDto
 */
export interface InboundFaxUrlResponseDto {
    /**
     * 
     * @type {string}
     * @memberof InboundFaxUrlResponseDto
     */
    signedUrl: string;
    /**
     * 
     * @type {number}
     * @memberof InboundFaxUrlResponseDto
     */
    expiresInMinutes: number;
}

/**
 * Check if a given object implements the InboundFaxUrlResponseDto interface.
 */
export function instanceOfInboundFaxUrlResponseDto(value: object): value is InboundFaxUrlResponseDto {
    if (!('signedUrl' in value) || value['signedUrl'] === undefined) return false;
    if (!('expiresInMinutes' in value) || value['expiresInMinutes'] === undefined) return false;
    return true;
}

export function InboundFaxUrlResponseDtoFromJSON(json: any): InboundFaxUrlResponseDto {
    return InboundFaxUrlResponseDtoFromJSONTyped(json, false);
}

export function InboundFaxUrlResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundFaxUrlResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'signedUrl': json['signedUrl'],
        'expiresInMinutes': json['expiresInMinutes'],
    };
}

export function InboundFaxUrlResponseDtoToJSON(json: any): InboundFaxUrlResponseDto {
    return InboundFaxUrlResponseDtoToJSONTyped(json, false);
}

export function InboundFaxUrlResponseDtoToJSONTyped(value?: InboundFaxUrlResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signedUrl': value['signedUrl'],
        'expiresInMinutes': value['expiresInMinutes'],
    };
}

